import React, { useEffect, useState } from "react";
import styled from "styled-components";

const FooterWrapper = styled.footer`
  width: 100%;
  border-top: 1px solid #e2e8f0;
  margin-top: 0;
  font-family: Inter, sans-serif;
  padding-top: 32px;
  padding-bottom: 32px;
`;

const FooterInner = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 4px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  min-height: 24px;

  @media screen and (max-width: 778px) {
    padding: 0 24px;
  }
`;

const FooterButton = styled.button`
  display: flex;
  align-items: center;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  font: inherit;
`;

const PoweredBy = styled.span`
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #334155;
  cursor: pointer;
`;

const PoweredByBold = styled.span`
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #334155;
`;

export default function Footer() {
  const [focusable, setFocusable] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setFocusable(true), 1200);
    return () => clearTimeout(t);
  }, []);

  return (
    <FooterWrapper>
      <FooterInner>
        <FooterButton
          type="button"
          tabIndex={focusable ? 0 : -1}
          onClick={() => window.open("https://hiverhq.com/", "_blank")}
          onKeyDown={(e) => e.key === "Enter" && window.open("https://hiverhq.com/", "_blank")}
        >
          <PoweredBy>
            Powered by <PoweredByBold>Hiver</PoweredByBold>
          </PoweredBy>
        </FooterButton>
      </FooterInner>
    </FooterWrapper>
  );
}
